import React from "react";
import Images from "./Images/Images.tsx";
import Videos from "./Videos/Videos.tsx";
import Files from "./Files/Files.tsx";
import TextComponents from "./TextComponents/TextComponents.tsx";
import Links from "./Links/Links.tsx";
import Audios from "./Audio/Audios.tsx";

interface ContentProps {
    group: any;
}

const MarkdownContent: React.FC<ContentProps> = ({ group }) => {
    const images = group.messages.flatMap(({ message }: { message: any }) =>
        message.role !== "tool" && Array.isArray(message.content)
            ? message.content.filter((item: any) => item.type === "image")
            : []
    );
    const videos = group.messages.flatMap(({ message }: { message: any }) =>
        message.role !== "tool" && Array.isArray(message.content)
            ? message.content.filter((item: any) => item.type === "video")
            : []
    );
    const audios = group.messages.flatMap(({ message }: { message: any }) =>
        message.role !== "tool" && Array.isArray(message.content)
            ? message.content.filter((item: any) => item.type === "audio")
            : []
    );
    const files = group.messages.flatMap(({ message }: { message: any }) =>
        message.role !== "tool" && Array.isArray(message.content)
            ? message.content.filter((item: any) => item.type === "file")
            : []
    );
    const links = group.messages.flatMap(({ message }: { message: any }) =>
        message.role !== "tool" && Array.isArray(message.content)
            ? message.content.filter((item: any) => item.type === "link")
            : []
    );
    const textComponents = group.messages.flatMap(({ message }: { message: any }) => {
        if (message.role !== "tool") {
            const thoughts = Array.isArray(message.content) ? message.content.filter((item: any) => item.type === "thinking" || item.type === "redacted_thinking") : [];
            const textItems = Array.isArray(message.content) ? message.content.filter((item: any) => item.type === "text") : [];
            const toolCalls = message.tool_calls || [];
            return [...thoughts, ...textItems, ...toolCalls];
        }
        return [];
    });
    
    return (
        <>
            <Videos
                offset={0}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={videos}
                isEditing={false}
            />
            <Images
                offset={videos.length}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={images}
                isEditing={false}
            />
            <Audios
                offset={videos.length + images.length}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={audios}
                isEditing={false}
            />
            <Files
                offset={videos.length + images.length + audios.length}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={files}
                isEditing={false}
            />
            <Links
                offset={videos.length + images.length + audios.length + files.length}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={links}
                isEditing={false}
                role={group.groupRole}
            />
            <TextComponents
                offset={videos.length + images.length + audios.length + files.length + links.length}
                editedContent={undefined}
                setEditedContent={undefined}
                iterObject={textComponents}
                isEditing={false}
                focusedLineContents={group.messages[0]?.metadata?.focusedLineContents}
            />
        </>
    );
};

export default MarkdownContent;
